<template>
  <div class="list-group">
    <button class="list-group-item list-group-item-action"
            v-for="order in orders"
            :key="order.id"
            @click="$emit('select', order)">
      <div class="d-flex">
        <div class="flex-fill">
          <div class="row">
            <div class="col-8">
              <font-awesome-icon :icon="['far', 'user']" class="fa-user" fixed-width/>
              {{ order.customer.name }}
            </div>
            <div class="col-4">
              <font-awesome-icon :icon="['far', 'id-badge']" class="fa-user ml-2" fixed-width/>
              {{ order.attendees }}
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <font-awesome-icon :icon="['far', 'calendar-alt']" class="fa-reservation" fixed-width/>
              {{ order.startTime | dateTime }}
            </div>
            <div class="col-4">
              <font-awesome-icon :icon="['far', 'clock']" class="fa-reservation ml-2" fixed-width/>
              {{ order.duration }}h
            </div>
          </div>
        </div>
        <div class="align-content-stretch align-middle">
          <font-awesome-icon icon="angle-right" class="text-primary h-100"/>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orders: []
    }
  },
  methods: {
    loadOrders() {
      this.$api.get('/orders').then(r => this.orders = r.data)
    }
  },
  mounted() {
    this.loadOrders()
  }
}
</script>
